<ng-container *ngIf="loading; else notificationsTemplate">
  <crm-spinner top="mt-3"></crm-spinner>
</ng-container>

<ng-template #notificationsTemplate>
  <div
    class="overflow-y-auto"
    (scroll)="onScrollEnd($any($event.target))"
    style="height: 400px">
    <div
      *ngFor="let notification of notifications | orderBy: '-created:date'"
      class="border-bottom-1 border-gray-200">
      <div class="flex">
        <div class="p-3">
          <crm-user-avatar
            *ngIf="notification.lastNotification?.user"
            [user]="{
              id: notification.lastNotification.user?.id,
              profile: notification.lastNotification.user?.profile
            }"></crm-user-avatar>
          <crm-user-avatar
            *ngIf="notification.lastNotification?.externalUser"
            [user]="{
              id: notification.lastNotification.externalUser?.id,
              profile: notification.lastNotification.externalUser?.profile
            }"></crm-user-avatar>
          <crm-user-avatar
            *ngIf="!notification.lastNotification?.user && !notification.lastNotification?.externalUser"
            [user]="{ id: -1, profile: { id: -1, name: 'Сервисное Уведомление', file: null } }"></crm-user-avatar>
        </div>
        <div class="py-3 pr-3 pb-2 w-full">
          <div class="flex justify-content-between">
            <div>
              <p class="font-bold">
                {{
                  notification?.lastNotification?.user?.profile?.name ||
                    notification?.lastNotification?.externalUser?.profile?.name ||
                    'Сервисное уведомление'
                }}
              </p>
              <p class="text-400 text-sm">
                {{ notification.lastNotification?.created | date: 'dd.MM.yyyy HH:mm' }}
              </p>
            </div>
            <p-tag
              *ngIf="notification?.notificationIds?.length > 1"
              [value]="notification?.notificationIds?.length?.toString()"
              styleClass="mr-2"
              [rounded]="true"></p-tag>
          </div>
          <p class="font-medium mb-1 mt-3">{{ notification.lastNotification?.subject?.title }}</p>
          <p
            class="break-word"
            style="max-height: 200px; overflow: hidden"
            [innerHTML]="notification.lastNotification?.text | truncate: 150 | safeHtml"></p>
          <div class="flex mt-2">
            <button
              pButton
              *ngIf="notification.lastNotification?.subject?.link"
              label="Перейти"
              [icon]="'pi pi-reply'"
              (click)="navigateToLink(notification);"
              class="p-button-secondary p-button-text p-button-sm"></button>

            <button
              pButton
              label="Прочитать"
              [icon]="'pi pi-eye'"
              class="p-button-secondary p-button-text p-button-sm ml-2"
              (click)="read(notification)"></button>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="paginationLoading"
      class="text-center">
      <p-progressSpinner
        [style]="{
          width: '50px',
          height: '50px'
        }"></p-progressSpinner>
    </div>

    <div *ngIf="!notifications?.length">
      <crm-no-data [size]="NoDataSize"></crm-no-data>
      <h4 class="font-normal text-center">
        {{ unreadCount === 0 ? 'Нет новых уведомлений' : 'Обновите список, для просмотра непрочитанных уведомлений' }}
      </h4>
    </div>
  </div>
</ng-template>
